// A legacy contact option carries its class name in `type`, so the type alone says whether it is a
// person. A CRM contact option always has `type: 'Backoffice::Contact'` - person vs. business lives
// on `person` instead - so the type check has to fall back to that.
export default function isPerson(data) {
  if (data.person !== undefined) return data.person;

  return data.type === 'Contacts::Person';
}
